export default __webpack_public_path__ + "static/media/profile.52206602.png";